<template>
    <div class="user-approval-component">
        <h4 class="text-center my-3">
        {{ model.email }}からの承認依頼
        </h4>

        <template v-if="!model || !model.approval || !model.approval.type">
            現在、依頼はありません。
        </template>

        <template v-else>
            <span>{{ trans.labels['emails.subject.wait-for-approval.' + model.approval.type] }}</span>
            <br>
            <br>
            <template v-if="model.approval.type === 'profile'">
                <table class="w-100 table table-bordered">
                    <tr>
                        <th></th>
                        <th>new</th>
                        <th>old</th>
                    </tr>
                    <tr v-for="f in user_fillable_profile_for_user">
                        <th :class="{ diff: model.approval.value[f] !== model.profile[f] }">{{ trans.models['users.profile.' + f] }}</th>
                        <td>{{ model.approval.value[f] }}</td>
                        <td>{{ model.profile[f] }}</td>
                    </tr>
                </table>
            </template>

            <br>
    
            <b-form-group
                label-cols-sm="2"
                label="回答"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <b-form-radio-group
                            v-model="model.answer"
                            >
                            <b-form-radio value="1">承認する</b-form-radio>
                            <b-form-radio value="0">否決する</b-form-radio>
                        </b-form-radio-group>
                        <input-error :errors="error.answer" />
                    </b-col>
                </b-row>
            </b-form-group>
    
            <b-form-group
                label-cols-sm="2"
                label="理由（否決は必須）"
                label-size="sm"
                @submit.stop.prevent
                >
                <b-row>
                    <b-col>
                        <b-form-textarea
                            v-model="model.reason"
                            size="sm"
                            placeholder=""
                            rows="3"
                            max-rows="6"
                            ></b-form-textarea>
                        <input-error :errors="error.reason" />
                    </b-col>
                </b-row>
            </b-form-group>
    
            <div class="text-center">
                <button class="btn btn-theme" @click="save">回答する</button>
            </div>
        </template>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import GridPage from '@/components/GridPage.vue'
import User from '@/components/User.vue'

export default {
    components: {
        GridPage,
        User,
    },
    props: {
        uuid: {
            type: String,
            required: true,
            default: '',
        },
    },
    computed: {
        ...mapGetters([
            'auth_level',
            'auth_name',
            'trans',
            'insurance_fillable_auto',
            'user_fillable_profile_for_user',
        ])
    },
    data() {
        return {
            model: {
                uuid: null,
                email: null,
                approval: {
                    type: null,
                    value: [],
                },
                profile: [],
                answer: null,
                reason: null,
            },
            error: {
            },
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        async fetch () {
            const response = await this.$store
                .dispatch('user/index', this.uuid)
                .then((response) => {
                    let modelUser = response.data.data || {}
console.log(modelUser)

                    this.model.uuid = modelUser.uuid
                    this.model.email = modelUser.email
                    this.model.approval = modelUser.approval
                    this.model.profile = modelUser.profile
                })
                .catch((error) => {
                })
        },
        async save () {
            this.error = {}
            const response = await this.$store
                .dispatch('user/approve', this.model)
                .then((response) => {
                    this.fetch()
                })
                .catch((error) => {
console.log(error)
                    this.error = error
                })
        },
    },
}
</script>

<style lang="scss" scoped>
.diff {
    background: #ff0000;
}
</style>

